import React from "react";

import { EmptyCell } from "../EmptyCell/EmptyCell.tsx";

interface PercentCellProps {
    amount: number | undefined | null;
}

export const PercentCell: React.FC<PercentCellProps> = ({ amount }) => {
    if (amount === null || amount === undefined) {
        return <EmptyCell />;
    }
    const n = Number(amount);
    if (!Number.isFinite(n)) {
        return <EmptyCell />;
    }
    return <>{n}%</>;
};
